// SQL Data Loader
// Loads trial data from the real data file with full sensor data

// Load trial data from the real data file
export const loadTrialDataFromSQL = async (trialType = 'NestleTrial1') => {
  try {
    // Import the generated route data with real GPS coordinates
    const { mockShipments, mockAnomalies, mockSensorData } = await import('./nestleTrialRoute.js');
    
    // Use the generated route data with proper distance and duration
    const fixedShipments = mockShipments; // Use the original values from the generated data
    
    // Use the generated anomalies directly
    const filteredAnomalies = mockAnomalies;
    
    return {
      shipments: fixedShipments,
      anomalies: filteredAnomalies,
      sensorData: mockSensorData
    };
  } catch (error) {
    return {
      shipments: [],
      anomalies: {},
      sensorData: {}
    };
  }
};

// Load all available trial data
export const loadAllTrialData = async () => {
  try {
    // Import the generated route data with real GPS coordinates
    const { mockShipments, mockAnomalies, mockSensorData } = await import('./nestleTrialRoute.js');
    
    // Use the generated route data with proper distance and duration
    const fixedShipments = mockShipments; // Use the original values from the generated data
    
    // Use the generated anomalies directly
    const filteredAnomalies = mockAnomalies;
    
    return {
      shipments: fixedShipments,
      anomalies: filteredAnomalies,
      sensorData: mockSensorData
    };
  } catch (error) {
    return {
      shipments: [],
      anomalies: {},
      sensorData: {}
    };
  }
};

// Load trial data with fallback
export const loadTrialDataWithFallback = async (trialType = 'NestleTrial1') => {
  try {
    return await loadTrialDataFromSQL(trialType);
  } catch (error) {
    return {
      shipments: [],
      anomalies: {},
      sensorData: {}
    };
  }
};

// Get available trial types
export const getAvailableTrialTypes = async () => {
  return ['NestleTrial1'];
}; 